/* eslint-disable */
import React from 'react';
import PageTwoColumn from '../Layouts/PageTwoColumn';
import LayoutTemplate2PagePropTypes from './LayoutTemplate2.page.props';

/**
 * LayoutTemplate2PageComponent
 * @export
 * @class LayoutTemplate2PageComponent
 * @extends {React.Component<LayoutTemplate2PageComponentComposedProps, LayoutTemplate2PageComponentState>}
 */
export class LayoutTemplate2PageComponent extends React.Component {
  /**
   * The `props` to seed when any specific prop receives an `undefined` value. **NOT** a `null` value
   * @static
   * @type {Partial<LayoutTemplate2PageComponentProps>}
   * @memberof LayoutTemplate2PageComponent
   */
  static defaultProps = {};

  /**
   * The name of the Component to display when debugging
   * @static
   * @type {`LayoutTemplate2Page`}
   * @memberof LayoutTemplate2PageComponent
   */
  static displayName = `LayoutTemplate2Page`;

  /**
   * The values to use to apply runtime typechecking on the props
   * @static
   * @type {object}
   * @memberof LayoutTemplate2PageComponent
   */
  static propTypes = LayoutTemplate2PagePropTypes;

  /**
   * Data specific to the `<LayoutTemplate2Page />` instance
   * @type {LayoutTemplate2PageComponentState}
   * @memberof LayoutTemplate2PageComponent
   */
  state = {};

  /**
   * Render the layoutTemplate2
   * @returns {React.Component} The rendered layoutTemplate2
   * @memberof LayoutTemplate2PageComponent
   */
  exampleComponent = () => (
    <div style={{ backgroundColor: `#ffb9ec`, height: `2000px` }}>
      Any component can go in this space e.g. 4 columns dashboard with cards, or single column T&amp;C's. For now its just tall box with lots of pink.
    </div>
  );

  /**
   * Render the component
   * @returns {React.Component} The rendered `<LayoutTemplate2Page />`
   * @memberof LayoutTemplate2PageComponent
   */
  render() {
    return (
      <PageTwoColumn defaultLanguageHeading="LayoutTemplate2" sidebarContentRight={this.exampleComponent()} title="LayoutTemplate2Page.PageTitle">
        {this.exampleComponent()}
      </PageTwoColumn>
    );
  }
}

export default LayoutTemplate2PageComponent;
